/*
 * Barra orizzontale di ordinamento e filtri: snippets/andpow-collectionFilters.liquid
 *
 * - apre e chiude le tendine (click, Esc, click fuori);
 * - se la disposizione scelta per il formato non ci sta, passa alla successiva (fit);
 * - con la barra fissa attiva nel formato corrente, la tiene sotto l'header quando anche questo è fisso
 *   e segna con is-stuck il momento in cui la barra è ferma sopra la griglia (sticky);
 * - intercetta i link della barra e della paginazione e aggiorna barra e griglia con la Section Rendering API,
 *   senza ricaricare la pagina. Se la richiesta fallisce si ripiega sulla navigazione normale.
 */
(function () {
  'use strict';

  var ROOT = '[data-acf-root]';
  var PRODUCTS = '.CollectionInner__Products';
  var pending = null;
  var pushed = false;

  function root() {
    return document.querySelector(ROOT);
  }

  function closeAll(except) {
    document.querySelectorAll(ROOT + ' [data-acf-dropdown].is-open').forEach(function (dropdown) {
      if (dropdown !== except) setOpen(dropdown, false);
    });
  }

  function setOpen(dropdown, open) {
    var toggle = dropdown.querySelector('[data-acf-toggle]');
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));

    dropdown.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!panel) return;

    panel.hidden = !open;
    panel.classList.remove('acf-panel--align-right');

    // Una tendina vicina al bordo destro si allinea a destra invece di uscire dallo schermo
    if (open && panel.getBoundingClientRect().right > document.documentElement.clientWidth - 8) {
      panel.classList.add('acf-panel--align-right');
    }
  }

  /*
   * Titolo e gruppi stanno nel contenitore senza uscire dai bordi né sovrapporsi?
   * Nelle disposizioni su una riga le liste non vanno a capo, quindi una barra troppo
   * larga si vede come un box oltre il bordo destro o sopra il box accanto.
   */
  function fits(bar) {
    var style = getComputedStyle(bar);
    var rect = bar.getBoundingClientRect();
    var left = rect.left + parseFloat(style.paddingLeft) - 1;
    var right = rect.right - parseFloat(style.paddingRight) + 1;
    var boxes = Array.prototype.map.call(bar.querySelectorAll('.acf-title, .acf-slot-a, .acf-slot-b'), function (el) {
      return el.getBoundingClientRect();
    }).filter(function (box) {
      return box.width > 0; // nella disposizione impilata i gruppi non generano un box
    });

    for (var i = 0; i < boxes.length; i++) {
      if (boxes[i].left < left || boxes[i].right > right) return false;
      for (var k = i + 1; k < boxes.length; k++) {
        var sameRow = boxes[i].top < boxes[k].bottom && boxes[k].top < boxes[i].bottom;
        var overlap = boxes[i].left < boxes[k].right && boxes[k].left < boxes[i].right;
        if (sameRow && overlap) return false;
      }
    }
    return true;
  }

  // Disposizione scelta → titolo sopra → tutto impilato, fermandosi alla prima che ci sta
  function fit() {
    var bar = root();
    if (!bar || bar.querySelector('[data-acf-dropdown].is-open')) return;

    bar.classList.remove('acf--fit-above', 'acf--fit-stacked');
    if (fits(bar)) return;

    bar.classList.add('acf--fit-above');
    if (fits(bar)) return;

    bar.classList.remove('acf--fit-above');
    bar.classList.add('acf--fit-stacked');
  }

  /*
   * Barra fissa (classi acf--sticky-d/t/m): il CSS decide se in questo formato è sticky,
   * qui si misura solo l'header. Fisso in cima (sticky o fixed con il bordo superiore a 0)
   * spinge la barra sotto di sé; in fondo alla finestra, come su mobile, non conta.
   */
  function sticky() {
    var bar = root();
    if (!bar) return;

    if (getComputedStyle(bar).position !== 'sticky') {
      bar.classList.remove('is-stuck');
      return;
    }

    var top = 0;
    var header = document.querySelector('.shopify-section--header');
    if (header) {
      var position = getComputedStyle(header).position;
      var box = header.getBoundingClientRect();
      if ((position === 'sticky' || position === 'fixed') && box.top <= 1 && box.bottom > 0) top = Math.round(box.bottom);
    }

    bar.style.setProperty('--acf-sticky-top', top + 'px');
    bar.classList.toggle('is-stuck', window.pageYOffset > 0 && bar.getBoundingClientRect().top <= top + 1);
  }

  function sectionId(bar) {
    var section = bar.closest('.shopify-section');
    return section ? section.id.replace('shopify-section-', '') : null;
  }

  function stripSectionId(container) {
    container.querySelectorAll('a[href*="section_id="]').forEach(function (link) {
      var url = new URL(link.href, location.href);
      url.searchParams.delete('section_id');
      link.href = url.pathname + url.search + url.hash;
    });
  }

  function navigate(url, push) {
    var bar = root();
    var products = document.querySelector(PRODUCTS);
    var id = bar && sectionId(bar);

    if (!bar || !products || !id || !window.fetch || !window.DOMParser) {
      location.href = url;
      return;
    }

    var focusedKey = null;
    var active = document.activeElement;
    if (active && bar.contains(active)) {
      var holder = active.closest('[data-acf-dropdown]');
      focusedKey = holder ? holder.getAttribute('data-acf-key') : null;
    }

    var requestUrl = new URL(url, location.href);
    requestUrl.searchParams.set('section_id', id);

    if (pending) pending.abort();
    pending = window.AbortController ? new AbortController() : null;

    products.classList.add('acf-loading');
    bar.setAttribute('aria-busy', 'true');

    fetch(requestUrl.toString(), { credentials: 'same-origin', signal: pending ? pending.signal : undefined })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextBar = doc.querySelector(ROOT);
        var nextProducts = doc.querySelector(PRODUCTS);
        if (!nextBar || !nextProducts) throw new Error('markup');

        stripSectionId(nextBar);
        stripSectionId(nextProducts);

        bar.innerHTML = nextBar.innerHTML;
        fit();
        products.innerHTML = nextProducts.innerHTML;
        products.classList.add('acf-swapped');
        products.classList.remove('acf-loading');
        bar.removeAttribute('aria-busy');

        if (push) {
          history.pushState({ acf: true }, '', url);
          pushed = true;
        }

        if (focusedKey) {
          // L'ordinamento può esistere due volte (desktop e mobile): si sceglie quello visibile
          var toggles = bar.querySelectorAll('[data-acf-key="' + focusedKey + '"] [data-acf-toggle]');
          for (var i = 0; i < toggles.length; i++) {
            if (toggles[i].offsetParent !== null) {
              toggles[i].focus();
              break;
            }
          }
        }

        // Barra ferma in cima: la griglia nuova riparte subito sotto la barra
        if (bar.classList.contains('is-stuck')) {
          var gap = products.getBoundingClientRect().top - bar.getBoundingClientRect().bottom;
          if (gap < 0) window.scrollBy({ top: gap, behavior: 'smooth' });
        } else {
          var top = bar.getBoundingClientRect().top;
          if (top < 0) window.scrollBy({ top: top - 20, behavior: 'smooth' });
        }

        document.dispatchEvent(new CustomEvent('acf:updated', { detail: { url: url } }));
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        location.href = url;
      });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest(ROOT + ' [data-acf-toggle]');
    if (toggle) {
      var dropdown = toggle.closest('[data-acf-dropdown]');
      var open = !dropdown.classList.contains('is-open');
      closeAll(dropdown);
      setOpen(dropdown, open);
      return;
    }

    if (!event.target.closest(ROOT + ' [data-acf-dropdown]')) closeAll();

    var link = event.target.closest('a[data-acf-link], ' + PRODUCTS + ' .Pagination a[href]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;

    event.preventDefault();
    closeAll();
    navigate(link.href, true);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest(ROOT + ' form[data-acf-form]');
    if (!form) return;

    event.preventDefault();
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (value !== '') params.append(key, value);
    });
    closeAll();
    navigate(form.action.split('?')[0] + '?' + params.toString(), true);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector(ROOT + ' [data-acf-dropdown].is-open');
    if (!open) return;
    setOpen(open, false);
    open.querySelector('[data-acf-toggle]').focus();
  });

  var fitFrame = null;
  window.addEventListener('resize', function () {
    if (fitFrame) cancelAnimationFrame(fitFrame);
    fitFrame = requestAnimationFrame(function () {
      fit();
      sticky();
    });
  });

  var stickyFrame = null;
  window.addEventListener('scroll', function () {
    if (stickyFrame) return;
    stickyFrame = requestAnimationFrame(function () {
      stickyFrame = null;
      sticky();
    });
  }, { passive: true });

  document.addEventListener('shopify:section:load', function () {
    fit();
    sticky();
  });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  fit();
  sticky();

  window.addEventListener('popstate', function () {
    // Solo dopo almeno un aggiornamento senza ricarica: un cambio di sola ancora non riguarda la barra
    if (pushed && root()) navigate(location.href, false);
  });
})();
